(() => {
  'use strict';

  if (window.nextdevVideoWithTextReady) return;
  window.nextdevVideoWithTextReady = true;

  const ROOT = '.nextdev--video-with-text';
  const PAUSE_BTN = '.nextdev--video-with-text--video--pause';
  const MUTE_BTN = '.nextdev--video-with-text--video--mute';

  const userPaused = new WeakSet();

  const getParts = (el) => {
    const root = el.closest(ROOT);
    if (!root) return null;

    return {
      video: root.querySelector('video'),
      pauseBtn: root.querySelector(PAUSE_BTN),
      muteBtn: root.querySelector(MUTE_BTN),
    };
  };

  const syncButtons = (video) => {
    const parts = getParts(video);
    if (!parts) return;

    if (parts.pauseBtn) parts.pauseBtn.dataset.paused = String(video.paused);
    if (parts.muteBtn) parts.muteBtn.dataset.muted = String(video.muted);
  };

  const safePlay = (video) => {
    const promise = video.play();
    if (promise) {
      promise.catch((err) => console.warn('Video play failed:', err));
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(`${PAUSE_BTN}, ${MUTE_BTN}`);
    if (!btn) return;

    const parts = getParts(btn);
    if (!parts || !parts.video) return;

    const { video } = parts;

    if (btn.matches(PAUSE_BTN)) {
      if (video.paused) {
        userPaused.delete(video);
        safePlay(video);
      } else {
        userPaused.add(video);
        video.pause();
      }
    } else {
      video.muted = !video.muted;
    }

    syncButtons(video);
  });

  ['play', 'pause', 'volumechange'].forEach((type) => {
    document.addEventListener(
      type,
      (e) => {
        const video = e.target;
        if (video instanceof HTMLVideoElement && video.closest(ROOT)) {
          syncButtons(video);
        }
      },
      true
    );
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting) {
          if (video.paused && !userPaused.has(video)) safePlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  const init = (scope) => {
    scope.querySelectorAll(`${ROOT} video`).forEach((video) => {
      observer.observe(video);
      syncButtons(video);
    });
  };

  init(document);

  document.addEventListener('shopify:section:load', (e) => init(e.target));

  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(`${ROOT} video`).forEach((video) => {
      observer.unobserve(video);
    });
  });
})();